/**
 * Employer entity index page
 */

import { EntityIndex } from './base';
import { canonicalPath } from '@electinfo/common';
import { matchLeafDetailPath } from './leaf-detail';
import { loadEmployerDetail } from './leaf-profiles';
import type { EntityConfig, EntitySearchResult } from './types';

function formatCurrency(amount: number): string {
  if (amount >= 1_000_000_000) {
    return `$${(amount / 1_000_000_000).toFixed(1)}B`;
  } else if (amount >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(1)}M`;
  } else if (amount >= 1_000) {
    return `$${(amount / 1_000).toFixed(0)}K`;
  }
  return `$${amount.toLocaleString()}`;
}

class EmployerIndex extends EntityIndex {
  protected setup(): void {
    const detailId = matchLeafDetailPath('employers');
    if (detailId) {
      void loadEmployerDetail(detailId);
      return;
    }
    super.setup();
  }

  getConfig(): EntityConfig {
    return {
      entityType: 'Employer',
      placeholder: 'Search employers by name...',
      browseTitle: 'All Employers',
      sortField: 'total_employee_contributions',
      sortOrder: 'DESC',
      formatResult: (result: EntitySearchResult) => {
        const totalContributions = result.score ? formatCurrency(result.score) : '';
        return {
          url: `/${canonicalPath('Employer', result.id)}/`,
          name: result.name || '',
          meta: totalContributions ? `${totalContributions} in employee contributions` : 'Employer Organization'
        };
      }
    };
  }
}

new EmployerIndex();
